import React, {useState} from 'react'
import { MenuItem } from './MenuItem';

const MenuSection = (props) => {
    const menuSection = props.menuSection;
    return (
        <div className="row">
            <div className="card-header">
                <p className="h6"> {menuSection.section_name}</p>
                <p className={menuSection.description ? "": "d-none"}>Description: {menuSection.description}</p>
            </div>
            <div className="row card-body ms-1 p-2">
                <ul className="list-group">
                    {menuSection.menu_items.map((menuItem) =>
                        <MenuItem item={menuItem} />
                    )}
                </ul>

            </div>
        </div>
    )
}

export default MenuSection
